<template>
    <div class="mt-4" v-if="currentJourney" >
        <div class="">
            <div class="row  pt-3 pb-3 mt-n1" v-if="taxis.length"  >
                <div class="col-6 ">
                    <p class="taxi-text">Taxi Operators</p>
                </div>
                <div class="col-6">
                    <p class="taxi-text"> Contact Numbers</p>
                </div>
            </div>
             <div v-else>
                There are no local taxi operators.
            </div>
            <div class="border-scroll" v-if="taxis.length"  >
                <div class="pt-3 pb-3mt-n1 border-taxis">
                    <div class=" col-12 pb-4 pt-4  pl-0 taxi-modal"  v-for="taxiItem in taxis" :key="taxiItem.name">
                        <div class="d-flex mb-3">
                            <div class="col-6">
                                {{ taxiItem.name }}
                            </div>
                            <div class="col-6 ">
                                <a class="taxi-number" :href="'tel:' + taxiItem.phone">
                                    <svg-icon :name="brand+'/phone'" width="12" class="mr-2" />
                                     <svg-icon aria-label="phone icon"  name="phone" width="auto" height="15"></svg-icon>
                                    {{ taxiItem.phone }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
        }
    },
    props: {
        journeyType: {
            type: String,
            default: 'depart',
        },
    },
    computed: {
        ...mapState([
            'currentJourney',
        ]),
        taxis() {
            return this.currentJourney[this.journeyType].taxis
        },
    },
}
</script>
